import { ApiService } from 'services';

export const CHECK_FORM_PDF_EXISTENCE_REQUEST = 'CHECK_FORM_PDF_EXISTENCE_REQUEST';
export const CHECK_FORM_PDF_EXISTENCE_SUCCESS = 'CHECK_FORM_PDF_EXISTENCE_SUCCESS';
export const CHECK_FORM_PDF_EXISTENCE_FAILURE = 'CHECK_FORM_PDF_EXISTENCE_FAILURE';

function requestCheckFormPdfExistence() {
  return {
    type: CHECK_FORM_PDF_EXISTENCE_REQUEST,
    isCheckingFormPdfExistence: true,
    formPdfExists: false
  };
}

function receiveCheckFormPdfExistence() {
  return {
    type: CHECK_FORM_PDF_EXISTENCE_SUCCESS,
    isCheckingFormPdfExistence: false,
    formPdfExists: true
  };
}

function rejectCheckFormPdfExistence(formPdfExistenceError) {
  return {
    type: CHECK_FORM_PDF_EXISTENCE_FAILURE,
    isCheckingFormPdfExistence: false,
    formPdfExists: false,
    formPdfExistenceError
  };
}

export function checkFormPdfExistence(formId) {
  return (dispatch) => {
    dispatch(requestCheckFormPdfExistence());

    const promise = () => ApiService
      .getFormPdf({ id: formId, isAdditional: false })
      .then((response) => {
        if (response.status !== 200) {
          dispatch(rejectCheckFormPdfExistence(response.status));
          return Promise.reject(response);
        }
        return dispatch(receiveCheckFormPdfExistence());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(rejectCheckFormPdfExistence(error));
        }
      });
    return promise();
  };
}
